/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Not_FoundInputs */

const en_blog_not_found = /** @type {(inputs: Blog_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not find that article.`)
};

const lv_blog_not_found = /** @type {(inputs: Blog_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šādu rakstu neizdevās atrast.`)
};

/**
* | output |
* | --- |
* | "We could not find that article." |
*
* @param {Blog_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_not_found = /** @type {((inputs?: Blog_Not_FoundInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Not_FoundInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_not_found(inputs)
	return en_blog_not_found(inputs)
});